import StickyFiles from './StickyFiles';
export default StickyFiles;